import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../context/MyContext";

// const DEADLINE = process.env.REACT_APP_TIMER;
const DEADLINE = 120
const ProgressBar = props => {

  const { paramId } = useContext(MyContext);

  const { time, isProcessing, handleTimer, sendTimerValue, onFinish } = props;
  const [timer, setTimer] = useState(time)

  useEffect(() => {
    onFinish(timer)
    if (!timer) {
      handleTimer()
      return
    };
    const interverId = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interverId);
  }, [timer])

  useEffect(() => {
    if (paramId) {
      setTimer(DEADLINE)
    }
  }, [paramId])
  const progress = timer / time;
  return (
    <div className="progress-bar">
      <div className="inner">
        {/* <div className="rest-time" style={progress > 0.2 ? { color: 'white' } : null}>{`${Math.floor(timer / 60)}:${(String(timer % 60)).padStart(2, "0")}`}</div> */}
        <div className="background" >
          <div
            style={{
              width: `${progress * 100}%`,
              height: "100%",
              // backgroundColor: "rgba(85, 69, 228, 1)",
              backgroundImage: 'linear-gradient(to right, rgba(246, 56, 159, 1) 0%, rgba(65, 116, 248, 1) 100%',
              transition: 'all ease 1.2s',
              borderRadius: '2rem',

            }}
          />
        </div>
        <div
          className="full-time"
        >
          {`${Math.floor(timer / 60)}:${String(timer % 60).padStart(2, '0')}`}
        </div>
      </div>
    </div>
  )
}
export default ProgressBar;
